module.exports = __webpack_public_path__ + "img/vol05_character_img03.66f6fa76.png";